import React from 'react'
import ExcelJS from 'exceljs'
import { IResponseGetAllQuizsRowData } from '@apiinterface/IQuiz'
import { Button } from '@mantine/core'

const generateAndDownloadExcel = (data: IResponseGetAllQuizsRowData[]) => {
    // Create a new Excel workbook
    const workbook = new ExcelJS.Workbook()
    const worksheet = workbook.addWorksheet('Sheet 1')

    // Add headers
    worksheet.addRow([
        'ไอดีรายการข้อมูล',
        'รหัสบุคคล',
        'ประเภทบุคคล',
        'Q1 (เป้าหมายชีวิต)',
        'Q2 (เงินออมต่อเดือน)',
        'Q3 (แนวความคิด)',
        'Q4 (เคยคำนวณ)',
        'ประกัน mtl',
        'ประกันอื่นๆ',
        'คลิกค้นหา',
        'ทำแบบประเมินเมื่อ',
    ])

    // Add data
    data.forEach((item) => {
        worksheet.addRow([
            item.quiz_id,
            item.person_id,
            item.person_type,
            item.question_1,
            item.question_2,
            item.question_3,
            item.question_4,
            item.life_insurance_mtl,
            item.life_insurance_other,
            item.click_tracking_1,
            item.created_at,
        ])
    })

    // Generate the Excel file and download it
    workbook.xlsx.writeBuffer().then((buffer) => {
        const blob = new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        })
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = 'data.xlsx'
        document.body.appendChild(a)
        a.click()
        window.URL.revokeObjectURL(url)
        document.body.removeChild(a)
    })
}

const DownloadExcel = ({ data }: { data: IResponseGetAllQuizsRowData[] }) => {
    return (
        <Button
            mt='26px'
            onClick={() => {
                generateAndDownloadExcel(data)
            }}
        >
            Download Excel
        </Button>
    )
}

export default DownloadExcel
